import { useCallback, useContext } from "react";
import { AgxTicket, TicketsClient } from "./TicketsClient";
import AzureAuthProvider from "../providers/AzureAuthProvider";
import { getBaseUrl } from "../auth/localDevelopment";

const baseUrl = getBaseUrl();

export const createTicketsClient = async (
  getAuthToken: () => Promise<string | void>
) => {
  const ticketsClient = new TicketsClient(`${baseUrl}/releases`);

  const authToken = await getAuthToken();

  if (!authToken) {
    throw new Error("No auth token could be retrieved");
  }

  ticketsClient.setAuthToken(authToken);

  return ticketsClient;
};

export const useCreateTicketsClient = () => {
  const getAuthToken = useContext(AzureAuthProvider);

  const createTicketsClientFunc = useCallback(
    () => createTicketsClient(getAuthToken),
    [getAuthToken]
  );

  return createTicketsClientFunc;
};

export const useGetTickets = () => {
  const createTicketsClient = useCreateTicketsClient();

  const getQualityAssuranceTickets = useCallback(async (): Promise<
    AgxTicket[]
  > => {
    const ticketsClient = await createTicketsClient();
    const tickets = await ticketsClient.getQualityAssuranceTickets();

    return tickets;
  }, [createTicketsClient]);

  return getQualityAssuranceTickets;
};
